module.exports = __webpack_public_path__ + "img/kp.92f5553d.svg";